/**
 * File: image-carousel.js
 *
 * Import and initialize functions for the Image Carousel
 */

 export default {
	init() {
    this.render();
	},
	render() {
    function addPagination() {
      const imageCarousel = document.querySelector('.elementor-widget-image-carousel');
      // const settings = JSON.parse(imageCarousel.dataset.settings);

      if (!imageCarousel) return;
      const carousel = imageCarousel.querySelector('.elementor-image-carousel');
      const pagination = imageCarousel.querySelector('.swiper-pagination-bullets');
      const carouselNav = imageCarousel.querySelectorAll('.elementor-widget-image-carousel .swiper-pagination-bullet');
      carouselNav.forEach((el, i) => {
        el.textContent = i + 1;
      });
      pagination.after(carousel);
    }
    addPagination();
    this.a11y();

    window.addEventListener('resize', () => {
      addPagination();
      setTimeout(() => {
        this.a11y();
      }, 600);
    });
	},
  a11y() {
    const imageCarousel = document.querySelector('.elementor-widget-image-carousel');
    if (!imageCarousel) return;

    const bullets = [...imageCarousel.querySelectorAll('.swiper-pagination-bullet')];
    const slides = [...imageCarousel.querySelectorAll('.swiper-slide')];
    const {
      slides_to_scroll_mobile,
      slides_to_scroll_tablet,
      slides_to_scroll,
    } = JSON.parse(imageCarousel.dataset.settings);

    let chunkSize;
    switch(true) {
      case this.breakpoint() === 'mobile':
        chunkSize = slides_to_scroll_mobile; // 1
        break;
      case this.breakpoint() === 'tablet':
        chunkSize = slides_to_scroll_tablet; // 2
        break;
      default:
        chunkSize = slides_to_scroll; // 3
    }

    const handleSlideSwitch = (activeGroupSlide) => {
      const chunks = this.spliceIntoChunks([...imageCarousel.querySelectorAll('.swiper-slide')], chunkSize);
      const activeGroupSlideEle = chunks[activeGroupSlide - 1] || chunks[0];
      
      const srHide = () => {
        slides.forEach((slide) => {
          slide.setAttribute('aria-hidden', true);
          const image = slide.querySelector('img');
          image.removeAttribute('tabindex');
        });
      };
  
      const srShow = () => {
        activeGroupSlideEle.forEach((item, i) => {
          item.setAttribute('aria-hidden', false);
          const image = item.querySelector('img');

          if (!activeGroupSlide) { return; }

          if (!i) {
            image.setAttribute('tabindex', 0);
            image.focus();
            setTimeout(() => {
              image.setAttribute('tabindex', -1);
            }, 99);
          }
        });
      };

      srHide();
      setTimeout(() => {
        srShow();
      }, 600);
    };
    handleSlideSwitch();

    bullets.forEach((bullet) => {
      bullet.addEventListener('click', (e) => {
        const isMouseClick = e.offsetX || e.offsetY;
        const activeGroupSlide = Number(bullet.textContent);

        if (isMouseClick) { return; }
        handleSlideSwitch(activeGroupSlide);
      });
    });
  },
  // helper fns
  breakpoint() {
    switch(true) {
      case window.matchMedia( '(min-width: 1024px)' ).matches:
        return 'desktop';
      case window.matchMedia( '(min-width: 768px)' ).matches:
        return 'tablet';
      default:
        return 'mobile';
    }
  },
  spliceIntoChunks(arr, chunkSize) {
    const res = [];
    while (arr.length > 0) {
        const chunk = arr.splice(0, chunkSize);
        res.push(chunk);
    }
    return res;
  },
};